<template>
  <div>
    <HeaderLogin />
    <div class="container">
      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(onSubmit)" novalidate>
          <b-row class="mt-5 justify-content-center" align-v="center">
            <b-col md="4">
              <b-card title="Recuperação de palavra-passe">
                <div v-if="!sent">
                  <p class="text-sm">Introduza a nova palavra-passe.</p>
                  <validation-provider
                    name="Endereço de email"
                    :rules="{ required: true }"
                    v-slot="validationContext"
                  >
                    <b-form-group label="Endereço de email" label-for="email">
                      <b-form-input
                        id="email"
                        name="email"
                        v-model="login.email"
                        :state="validateState(validationContext)"
                      ></b-form-input>
                    </b-form-group>
                  </validation-provider>

                  <validation-provider
                    name="Nova palavra passe"
                    rules="required|min:8"
                    vid="password"
                    v-slot="validationContext"
                  >
                    <b-form-group label="Nova palavra-passe" label-for="password">
                      <b-form-input
                        id="password"
                        type="password"
                        name="password"
                        v-model="login.password"
                        :state="validateState(validationContext)"
                      ></b-form-input>                    
                      <b-form-invalid-feedback id="input-2-live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                    </b-form-group>                  
                  </validation-provider>
                  <validation-provider
                    name="Confirme a nova palavra passe"
                    vid="confirm" rules="required|confirmed:password"
                    v-slot="validationContext"
                  >
                    <b-form-group label="Confirme a palavra-passe" label-for="password_confirm">
                      <b-form-input
                        id="password_confirm"
                        type="password"
                        name="password_confirm"
                        v-model="login.password_confirm"
                        :state="validateState(validationContext)"
                      ></b-form-input>
                      <b-form-invalid-feedback id="input-2-live-feedback">A confirmação da palavra-passe não está igual à nova palavra-passe.</b-form-invalid-feedback>
                    </b-form-group>                
                  </validation-provider>
                  <div class="text-right">
                    <b-btn variant="success" :disabled="!passwordsMatch || working" type="submit">Confirmar</b-btn>                  
                  </div>
                </div>
                <div v-if="sent">
                  <p>A palavra-passe foi atualizada com sucesso.<br>
                  <router-link to="/login">Clique aqui para iniciar sessão</router-link>
                  </p>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </div>
    <FooterFront />
  </div>
</template>


<script>
import HeaderLogin from "../../containers/Header_front.vue";
import FooterFront from "../../containers/Footer_front.vue";

export default {
  name: "ResetForm",
  data() {
    return {
      sent: false,
      login: {
        email: "",
        password: "",
        password_confirm: "",
      },
      token: "",
      working: false,
    };
  },
  components: {
    HeaderLogin,
    FooterFront,
    // Header
  },
  computed: {
    passwordsMatch: function() {
      console.log(this.password)
      return this.login.password === this.login.password_confirm && this.login.password != ""
    }
  },
  methods: {
    onSubmit() {
      this.working = true;
      // e.preventDefault();      
      // var redirectTo = { name: "login" };
      const data = {
        email: this.login.email,
        password: this.login.password,
        password_confirmation: this.login.password_confirm,
        token: this.token,
      };
      console.log("data",data)
     
      this.axios.post("auth/reset", data).then(() => {
        this.$bvToast.toast("Palavra-passe alterada com sucesso", {
          autoHideDelay: 5000,
            variant: "success",
            solid: true,
          });
          this.sent = true; 
      }).catch(() => {
        this.working = false;
          this.$bvToast.toast(
            "Houve um erro a alterar a palavra passe",
            { autoHideDelay: 5000, variant: "danger", solid: true }
          );
      })      
    },
    validateState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
  },
  created() {
    this.token = this.$route.params.token;
  }
};
</script>

<style>
body {
  background-color: #e4e5e6 !important;
}

.text-sm {
  font-size: 0.8rem;
}
</style>